import React from 'react';
import styled from 'styled-components';
import {getHelmetForMetaTags} from 'epic-ue-shared';
import {
    DynamicSections,
    ImageHero,
    Subnav,
    SubnavProps,
    TemplateThemeProps,
    VerticalSpacer,
    GeneralLandingPageData,
    GeneralLandingPageSections,
    ImmersiveHeaderSection,
    CmsComponentMapper,
    DynamicHeaderProps
} from 'epic-ue-ui';
import {UeThemeProvider, ueLightTheme, ueDarkTheme, useSetCurrentAccentColor} from 'epic-ue-theme';

const Styled = styled.div`
    position: relative;
    overflow: hidden;
`;
interface Properties {
    pageData: GeneralLandingPageData;
}

const EventStardustPage = ({pageData}: Properties): JSX.Element => {
    const {
        subnav = {} as SubnavProps,
        themeConfig = {} as TemplateThemeProps,
        sections = {} as GeneralLandingPageSections,
        bottomPageVerticalSpacer,
        header
    } = pageData;
    const dynamicHeader = (header as DynamicHeaderProps) || {};
    const {headerOptions} = dynamicHeader;
    const {items = []} = sections;
    const {accentColor, theme} = themeConfig;

    useSetCurrentAccentColor(accentColor);

    return (
        <>
            <UeThemeProvider theme={theme === 'light' ? ueLightTheme : ueDarkTheme}>
                <Styled className={theme}>
                    {getHelmetForMetaTags(pageData)}
                    <CmsComponentMapper
                        dynamicPageDataArray={headerOptions}
                        elementMapping={{
                            imageHero: <ImageHero accentColor={accentColor} />,
                            immersiveHeader: <ImmersiveHeaderSection accentColor={accentColor} />
                        }}
                    />
                    <Subnav {...subnav} accentColor={accentColor} />
                    <DynamicSections theme={theme} items={items} accentColor={accentColor} />
                    {bottomPageVerticalSpacer && <VerticalSpacer variant="section" />}
                </Styled>
            </UeThemeProvider>
        </>
    );
};

export default EventStardustPage;
